import React from 'react'
import Page from '../components/Page'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import { MdCameraAlt, MdFace, MdDone, MdClear, MdCreate, MdAdd, MdTransferWithinAStation } from 'react-icons/md'
import { BsPlusSquareFill } from 'react-icons/bs'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import classnames from 'classnames'
import PosShippingForm from '../components/PosShippingForm'
import { IconContext } from 'react-icons/lib'
import PosPromoTable from './PosPromoTable'

class PosMembershipTierForm extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      isEdit: false,
      isGlobal: true,
      membership_id: this.props.match.params.id,
      tier_id: '',
      tier_name: '',
      entry_level: '',
      points_type: '',
      max_points: '',
      conversion_rate: '',
      max_claim: '',
      min_claim: 1,
      tier_unit: '',
      expiry_duration: '',
      membershipList: [],
    }
  }

  componentDidMount() {
    // this.Membership()
    if (this.props.data.isGlobal) {
      if (this.props.data.isEdit) {
        let id = this.props.data.selectedId
        const data = this.props.data.membership_tier.find(e => e.id === id)
        this.setState({
          tier_id: id,
          tier_name: data.tier_name,
          points_type: data.points_type,
          entry_level: data.entry_level,
          max_points: data.max_points,
          conversion_rate: data.conversion_rate,
          max_claim: data.max_claim,
          min_claim: data.min_claim,
          tier_unit: data.tier_unit,
          expiry_duration: data.expiry_duration,
          isEdit: true,
          isGlobal: this.props.data.isGlobal,
        })
      }
    } else {
      //no global for membership
      this.setState({
        store_id: this.props.data.store_id,
        isGlobal: this.props.data.isGlobal,
        isEdit: this.props.data.isEdit,
      })
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  changeHandler = e => {
    let { name, value } = e.target

    if (name == 'min_claim' && value < 1) {
    } else {
      this.setState({
        [name]: value,
      })
    }
  }

  handleSubmit = event => {
    event.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    if (this.state.isGlobal) {
      if (!this.state.isEdit) {
        this.create(user, comp, url)
      } else {
        this.update(user, comp, url)
      }
    } else {
      //no global for membership
      this.add(user, comp, url)
    }
  }

  //   Membership = () => {
  //     const user = StorageService.getSession('user_info')
  //     const comp = StorageService.getSession('selected_org')
  //     const url = process.env.REACT_APP_UNITY_API2_URL
  //     const data = {
  //       session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
  //       company_id: comp.CompanyID,
  //     }

  //     axios
  //       .post(url + ':3001/v1/membership', data)
  //       .then(response => {
  //         const result = response.data
  //         const storeMembership = this.props.data.membershipList

  //         let MembershipOp = result.data.filter(x => !storeMembership.some(y => y.id === x.id))

  //         if (result.error == true && result.message != 'Success') {
  //           alert(result.message)
  //           return
  //         }

  //         if (this._isMounted) {
  //           this.setState({
  //             membershipList: MembershipOp,
  //           })
  //         }
  //       })
  //       .catch(error => {
  //         alert(error)
  //       })
  //   }

  create(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      membership_id: this.state.membership_id,
      tier_name: this.state.tier_name,
      entry_level: this.state.entry_level,
      points_type: this.state.points_type,
      max_points: this.state.max_points,
      conversion_rate: this.state.conversion_rate,
      max_claim: this.state.max_claim,
      min_claim: this.state.min_claim,
      tier_unit: this.state.tier_unit,
      expiry_duration: this.state.expiry_duration,
      created_by: user.email,
    }

    axios
      .post(url + ':3001/v1/membership/tier/create', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(<MdDone />, 'New membership tier added successfully.', 'success', false)
      })
      .catch(error => {
        alert(error)
      })
  }

  update(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      tier_id: this.state.tier_id,
      membership_id: this.state.membership_id,
      tier_name: this.state.tier_name,
      entry_level: this.state.entry_level,
      points_type: this.state.points_type,
      max_points: this.state.max_points,
      conversion_rate: this.state.conversion_rate,
      max_claim: this.state.max_claim,
      min_claim: this.state.min_claim,
      tier_unit: this.state.tier_unit,
      expiry_duration: this.state.expiry_duration,
      update_by: user.email,
    }

    axios
      .post(url + ':3001/v1/membership/tier/update', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(
          <MdDone />,
          'Membership tier updated successfully.',
          'success', //'error' post when return error
          false,
        )
      })
      .catch(error => {
        alert(error)
      })
  }

  //   add(user, comp, url) {
  //     const data = {
  //       session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
  //       store_id: this.state.store_id,
  //       promo_id: this.state.promo_id,
  //       added_by: user.email,
  //     }

  //     axios
  //       .post(url + ':3001/v1/store/promo/add', data)
  //       .then(response => {
  //         const result = response.data
  //         if (result.error == true) {
  //           this.props.closeModal(<MdClear />, result.message, 'error', false)
  //           return
  //         }

  //         this.props.closeModal(<MdDone />, 'New Promo added successfully.', 'success', false)
  //       })
  //       .catch(error => {
  //         alert(error)
  //       })
  //   }

  render() {
    console.log(this.state)
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>Membership {this.state.isGlobal ? 'Details' : 'List'}</ModalHeader>
        <ModalBody>
          {this.state.isGlobal ? (
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label>Name</Label>
                  <Input type="text" name="tier_name" value={this.state.tier_name} onChange={this.changeHandler} required />
                </FormGroup>
                <FormGroup>
                  <Label>Point Type</Label>
                  <Input type="select" name="points_type" value={this.state.points_type} onChange={this.changeHandler} required>
                    <option value=""></option>
                    <option value="Purchase">Purchase</option>
                    <option value="Order">Order</option>
                  </Input>
                </FormGroup>
                <FormGroup>
                  <Label>Entry Level</Label>
                  <Input type="number" name="entry_level" value={this.state.entry_level} onChange={this.changeHandler} required />
                </FormGroup>
                <FormGroup>
                  <Label>Max Points (0 if unlimited)</Label>
                  <Input type="number" name="max_points" value={this.state.max_points} onChange={this.changeHandler} required />
                </FormGroup>
                <FormGroup>
                  <Label>Conversion Rate</Label>
                  <Input type="number" name="conversion_rate" value={this.state.conversion_rate} onChange={this.changeHandler} required />
                </FormGroup>
                <FormGroup>
                  <Label>Maximum Claim Points (0 if unlimited)</Label>
                  <Input type="number" name="max_claim" value={this.state.max_claim} onChange={this.changeHandler} required />
                </FormGroup>
                <FormGroup>
                  <Label>Minimum Claim Points</Label>
                  <Input type="number" name="min_claim" value={this.state.min_claim} disabled={this.state.isEdit} onChange={this.changeHandler} required />
                </FormGroup>
                <FormGroup>
                  <Label>Conversion Unit</Label>
                  <Input type="number" name="tier_unit" value={this.state.tier_unit} onChange={this.changeHandler} required />
                </FormGroup>
                <FormGroup>
                  <Label>Expiry Duration</Label>
                  <Input type="number" name="expiry_duration" value={this.state.expiry_duration} onChange={this.changeHandler} required />
                </FormGroup>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label></Label>
                  <Input type="select" name="promo_id" onChange={this.changeHandler} required>
                    <option></option>
                    {this.state.promoList &&
                      this.state.promoList.map(item => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        )
                      })}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
          )}
        </ModalBody>
        <ModalFooter>
          <Button className="theme-button theme-button-secondary" onClick={this.props.onToggleModal()}>
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    )
  }
}

export default PosMembershipTierForm
